import React from "react";
import { useTranslation } from "react-i18next";

const StatusPill: React.FC<{ active: boolean; className?: string }> = ({
  active,
  className,
}) => {
  const { t } = useTranslation("common");
  return <div
    className={`${className || ""} items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium ${
      active
        ? "bg-green-50 text-green-700 border border-green-200"
        : "bg-red-50 text-gray-700 border border-gray-200"
    }`}
  >
    <div className="relative flex items-center">
      <span
        className={`w-1.5 h-1.5 rounded-full mr-1 ${
          active ? "bg-green-500" : "bg-red-400"
        }`}
      />
      {active ? (
        <span className="absolute w-1.5 h-1.5 rounded-full bg-green-500 animate-ping opacity-75" />
      ) : (
        <span className="absolute w-1.5 h-1.5 rounded-full bg-red-500 animate-ping opacity-75" />
      )}
    </div>
    {active ? t("active") : t("closed")}
  </div>
};
export default StatusPill;
